/**
 * Screen is active when the API reports a recent heartbeat (LastActive within 5 minutes).
 * @param {object|null|undefined} screen
 * @returns {boolean}
 */
export function isScreenActive(screen) {
  if (!screen) {
    return false;
  }

  const { isActive, Active, active } = screen;

  if (isActive === true || isActive === 'true' || isActive === 1 || isActive === '1') {
    return true;
  }
  if (isActive === false || isActive === 'false' || isActive === 0 || isActive === '0') {
    return false;
  }

  if (Active === true || Active === 'true' || Active === 1 || Active === '1') {
    return true;
  }
  if (Active === false || Active === 'false' || Active === 0 || Active === '0') {
    return false;
  }

  if (active === true || active === 'true' || active === 1 || active === '1') {
    return true;
  }

  return false;
}
